import { HTTPClient } from "../utils/request";

export default {
  store: ({ payload }) => HTTPClient.post(`/antt`, payload)
};
